const BASE_URL = 'http://10.58.52.162:3000/';

export const APIS = {
  signup: `${BASE_URL}users/signup`,
  login: `${BASE_URL}users/login`,
  review: `${BASE_URL}reviews`,
  orders: `${BASE_URL}orders`,
};
